<template>
  <v-card>
    <v-form
      ref="form"
      v-model="isFormValid"
      lazy-validation
      @submit.prevent="submit"
    >
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.name"
                label="Nome"
                hide-details="auto"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="selectedItem.roles"
                :items="userRoleOptions"
                :rules="formRules.userRolesRules"
                item-text="name"
                item-value="id"
                label="Perfil de Acesso"
                hide-details="auto"
                multiple
                clearable
                chips
                deletable-chips
                small-chips
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#0dc4b8" 
          text
          @click="$emit('onClose'); "
        >
          Cancelar
        </v-btn>
        <v-btn
          color="#0dc4b8" 
          text
          type="submit"
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ formButtonText }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
            

<script>
import { mapGetters, mapMutations } from 'vuex';
import UserRolesService from '../../services/user_roles.service';
import UsersService from '../../services/users.service';

export default {
  name: 'UserRolesForm',
  props: {
    selectedItem: {
        type: Object,
        required: true,
    }
  },
  data: () => ({
    formRules: {
      userRolesRules: [
        v => !!v && v.length > 0 || 'Perfil de Acesso é obrigatório',
      ],
    },
    isFormValid: true,
    isLoading: true,
    userRoleOptions: [],
  }),
  computed: {
    ...mapGetters(['permissions', 'user']),

    formButtonText () {
      return 'Editar'
    },
  },
  mounted() {
    this.loadFormOptions();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    loadFormOptions () {
      UserRolesService.get({ sort: 'name' })
        .then(({ data }) => {
          this.userRoleOptions = data.data;
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    submit () {
      if(this.$refs.form.validate()) {
        this.isLoading = true;

        UsersService.put(this.selectedItem, this.selectedItem.id)
          .then(() => {
            this.showSnackbar({ text: "Registro atualizado com sucesso!", color:"success" })
          })
          .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
          .finally(() => setTimeout(() => {this.isLoading = false; this.$emit('onSubmit'); }, 300));
      }
    },
  },
}
</script>
